export const SCHEMA_VERSION = '1.0.4'

export const BLOCK_TYPES = {
  NONE: 'none',
  CONCEPT_LAB: 'concept-lab',
  TRACKING_VALUES: 'tracking-values'
} as const

export type BlockTypesType = (typeof BLOCK_TYPES)[keyof typeof BLOCK_TYPES]

const BLOCK_TYPE_ALIASES = {
  concept: BLOCK_TYPES.CONCEPT_LAB,
  tracker: BLOCK_TYPES.TRACKING_VALUES
} as const

export type BlockTypeAliasType = keyof typeof BLOCK_TYPE_ALIASES

export const SUBJECT_TYPES = {
  CONCEPT: 'concept',
  WAVE: 'wave'
} as const

export const BLOCK_SUBJECT_TYPES = {
  [BLOCK_TYPES.CONCEPT_LAB]: SUBJECT_TYPES.CONCEPT,
  [BLOCK_TYPES.TRACKING_VALUES]: SUBJECT_TYPES.WAVE
} as const

export type SubjectTypesType = (typeof SUBJECT_TYPES)[keyof typeof SUBJECT_TYPES]

export const defaultAveragesUids = ['avg', 'row_averages@is.aytm']
export function isRowAveragesUid(uid: string) {
  return defaultAveragesUids.includes(uid)
}

export const defaultPreset = 'All'

export const defaultWave = 'asFielded'

export const defaultMinimumSampleSize = 0

export const checkBlockType = (type: unknown): BlockTypesType =>
  Object.values(BLOCK_TYPES).includes(type as BlockTypesType) ? (type as BlockTypesType) : null

export const checkPortalType = (type: unknown): BlockTypesType => {
  const blockType =
    (type as BlockTypeAliasType) in BLOCK_TYPE_ALIASES
      ? BLOCK_TYPE_ALIASES[type as BlockTypeAliasType]
      : (type as BlockTypesType)
  return blockType ? checkBlockType(blockType) : null
}

export const blockTypeToSubjectType = (type: Exclude<BlockTypesType, 'none'>): SubjectTypesType =>
  BLOCK_SUBJECT_TYPES[type] || SUBJECT_TYPES.CONCEPT

export const MAX_SUBJECT_TITLE_LENGTH = 120
export const MAX_PORTAL_TITLE_LENGTH = 100

export const defaultEditor = {
  type: 'add',
  itemIndex: -1,
  menuIndex: -1,
  error: false,
  scroll: false,
  changed: false
} as const

export const ERRORS = {
  title: {
    empty: 'Title must not be empty!',
    duplicate: 'Choose a unique name!'
  },
  image: {
    upload: 'Error uploading image!',
    size: 'Maximum image size is 10mb'
  }
} as const

export const FETCH_BULK_SIZE = 1000
